import React, { useState ,useEffect } from "react";
import { Button, Input, Select, Table } from "antd";
import { AiFillAccountBook } from "react-icons/ai";
import AdminNavbar from "../Navbar/AdminNavbar";
import UserNavbar from "../Navbar/UserNavbar";
import { BranchMasterAdd, BranchMasterDelete, BranchMasterFindAll, BranchMasterUpdate } from "../Api/All_Api";
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router-dom";


const BranchMaster = () => {
  const role = sessionStorage.getItem('role');
  // const role = sessionValue; // Uncomment to use the dynamic session role

    const sessionYear = sessionStorage.getItem('sessionYear');
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])


  const [errors, setErrors] = useState({
    branchName: '',
    branchMobile:'',
    branchAddress:'',

  });

const [pageSize, setPageSize] = useState(10);
const [filteredData, setFilteredData] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalEntries, setTotalEntries] = useState(0);
const[allBranch , setAllBranch]=useState([]);
const [branchId, setBranchId] = useState('');
const [branchName, setBranchName] = useState('');
const [branchMobile, setBranchMobile] = useState('');
const [branchAddress, setBranchAddress] = useState('');

const [updateButton, setUpdateButton] = useState(false);
const [saveButton, setSaveButton] = useState(true);

const handleSearch = (value) => {
  const filtered = allBranch.filter((item) =>
    Object.values(item).some((val) =>
      val.toString().toLowerCase().includes(value.toLowerCase())
    )
  );
  setFilteredData(filtered);
  setTotalEntries(filtered.length); // Update total entries count after filtering
  setCurrentPage(1);
};
//==========Pagination=======================
const handlePageSizeChange = (value) => {
  setPageSize(value);
};

  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
    setBranchName('');
    setBranchAddress('');
    setBranchMobile('');
    setErrors('');
  };

  // ========Submit data to table==============
  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};
    if (!branchName) {
      isValid = false;
      errorObj.branchName = " Name is required *";
    }
    if (!branchMobile) {
      isValid = false;
      errorObj.branchMobile = "Contact is required *";
    }
    if (!branchAddress) {
      isValid = false;
      errorObj.branchAddress = "Address is required *";
    }
    setErrors(errorObj); // Set error messages

    if (!isValid) return;
    const bodyData ={
        branchName: branchName,
        branchContact:branchMobile,
         branchAddress: branchAddress,
     
    }

   
    try {
      const response = await axios.post(BranchMasterAdd,bodyData );

      if (response.data === "CREATED") {
        toast.success('Branch added successfully!');
        fetchBranch();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
        toast.warn('Branch already exist!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
  };
  useEffect(() => {
    fetchBranch();
  }, []);
  // ========Update data from table============
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    window.scrollTo(0, 0);
    setBranchName(item.branchName);
    setBranchId(item.id);
    setBranchAddress(item.branchAddress);
    setBranchMobile(item.branchContact);

  };
  let isError = false;
  const fetchBranch = async () => {
    try {
      const response = await axios.get(BranchMasterFindAll);
      if (response.data !== null) {
        setAllBranch(response.data);
        setFilteredData(response.data);
        setTotalEntries(response.data.length); 
      }
      
    } catch (error) {
        if (!isError) {  
          console.error('Error fetching Branch:', error);
          toast.error('Failed to fetch branch data');
          isError = true;  
        }
    }
  };   
  const handleUpdate = async () => {
    let isValid = true;
    const errorObj = {};
    if (!branchName) {
      isValid = false;
      errorObj.branchName = "Branch is required *";
    }
    if (!branchMobile) {
      isValid = false;
      errorObj.branchMobile = "Contact is required *";
    }
    if (!branchAddress) {
      isValid = false;
      errorObj.branchAddress = "Address is required *";
    }
    setErrors(errorObj); // Set error messages

    if (!isValid) return;

    const bodyData ={
      id: branchId,
      branchName: branchName,
     branchContact:branchMobile,
      branchAddress: branchAddress,
   
    }

    try {
      const response = await axios.put(BranchMasterUpdate,bodyData );

      if (response.data === "UPDATED") {
        toast.success(' Updated successfully!');
        fetchBranch();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
              toast.warn('Branch already exist!');
              handleCancel();
            }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while updating data');
    }
  };

  // ========Delete data from table============
  const handleDeleteData = async (item) => {
      const confirmDelete = window.confirm(`Are you sure you want to delete the location"${item.branchName}"?`);
      if (!confirmDelete) return;

      try {
        const response = await axios.delete(`${BranchMasterDelete}?id=${item.id}`);
        if (response.data === "DELETED") {
          toast.success('Branch deleted successfully!');
          fetchBranch();
          handleCancel();
        }
      } catch (error) {
        console.error('Error during delete operation:', error);
        toast.error('Error occurred while deleting the stream');
      }
  };
  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
    const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => index + 1,
    },
  
    {
      title: "Branch Name",
      dataIndex: "branchName",
      key: "branchName",
    },
    {
      title: "Contact.",
      dataIndex: "branchContact",
      key: "customerMobile",
    },
    {
      title: "Address",
      dataIndex: "branchAddress",
      key: "branchAddress",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div>
          <span
          type="submit"
          onClick={() => handleEditDataButton(record)}
            style={{
              fontSize: "10px",
              color: "#349ff3",
              marginRight: "10px",
            }}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
          <span
            type="submit"
          onClick={() => handleDeleteData(record)}
            style={{
              fontSize: "10px",
              color: "blue",
              marginLeft: "10px",
            }}
          >
            <i className="fa-solid fa-trash"></i>
          </span>
        </div>
      ),
    },
  ];
  const validateMobileNumber = (value) => {
    // Check if the entered value contains non-digit characters
    if (/[^0-9]/.test(value)) {
      setErrors({
        ...errors,
        branchMobile: 'Contact should contain only digits.',
      });
    } else {
      setErrors({
        ...errors,
        branchMobile: '', // Clear error if valid
      });
    }

    // Set the mobile number value
    setBranchMobile(value);
  };
  return (
    <>
      {role === 1 && <AdminNavbar />}
      {role === 2 && <UserNavbar />}
      <div className="p-0 m-0">
        {/* Header Section */}
        <div
          className="row m-0"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
            fontSize: "19px",
            backgroundColor: "#2E86C1",
            color: "white",
          }}
        >
          <div
            className="col-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              //  marginLeft: "50px",
            }}
          >
          <span className="px-md-5">
            <AiFillAccountBook style={{ marginRight: "10px" }} />
            Branch Master
                      </span>
          </div>
        </div>

       
        
        <div className='row m-0 p-0 pt-3'>
          <div className='col-12 col-md-4'></div>
          <div className='col-12 col-md-4'>
              <div className="row px-md-5 mt-3  m-0">

                <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Branch:</label>
          </div>
          <div className="col-9">
            <Input
              placeholder="Enter  Name"
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
            />
            {errors.branchName && (
              <div className="errorField">{errors.branchName}</div>
            )}
          </div>
        </div>
      </div>
      
    {/* Address Input */}
    <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Address:</label>
          </div>
          <div className="col-9">
            <TextArea
              placeholder="Enter Address"
              value={branchAddress}
              onChange={(e) => setBranchAddress(e.target.value)}
            />
            {errors.branchAddress && (
              <div className="errorField">{errors.branchAddress}</div>
            )}
          </div>
        </div>
      </div>
    

      <div className="col-12 pt-2">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Contact:</label>
          </div>
          <div className="col-9">
            <Input
              placeholder="Enter Mobile No."
              value={branchMobile}
              type="tel"
              onChange={(e) => validateMobileNumber(e.target.value)} 
            />
            {errors.branchMobile && (
              <div className="errorField">{errors.branchMobile}</div>
            )}
          </div>
        </div>
      </div>
   


    {/* Buttons Section */}
    <div className="col-12 text-center pt-3">
      <Button
        type="button"
        className="CancelBtn mx-1"
     
        onClick={handleCancel}
      >
        Cancel
      </Button>
      {saveButton && (
        <Button
          type="button"
          className="SubmitBtn mx-1"
        
          onClick={handleSubmit}
        >
          Save
        </Button>
      )}
      {updateButton && (
        <Button
          type="button"
          className="UpdateBtn mx-1"
 
          onClick={handleUpdate}
        >
          Update
        </Button>
      )}
    </div>
  </div>




          <div
            className="col-12 p-0 mt-3"
            style={{ borderBottom: "2px solid #bfb597" }}
          ></div>
          </div></div></div>
        <div className='col-12 col-md-4'></div>
        

       

        {/*================ Table =========================*/}
                   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
                   <div className='col-12 col-md-2'></div>
                     <div  className="col-12 col-md-8 py-3 shadow border"
                       style={{ marginBottom: "50px", backgroundColor: "white" }}
                     >
                       <div
                         className="col-12 px-md-5"
                         style={{ display: "flex", justifyContent: "space-between" }}
                       >
                         <div>
                           <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                           <Select
                             defaultValue={pageSize}
                             onChange={handlePageSizeChange}
                             style={{ width: 120, textAlign: "center" }}
                           >
                             <Option value={10}>10</Option>
                             <Option value={20}>20</Option>
                             <Option value={30}>30</Option>
                           </Select>
                         </div>
           
                         <div className="pt-4 pt-md-0">
                           <Input.Search
                             placeholder="Search"
                             onSearch={handleSearch}
                             style={{ width: 200, marginBottom: 16 }}
                           />
                         </div>
                       </div>
           
                       <div style={{ backgroundColor: "white" }}>
                         <Table
                           bordered
                           style={{ padding: "0px 20px", overflowX: "auto" }}
                           columns={columns}
                           dataSource={filteredData}
                           pagination={{
                             pageSize: pageSize,
                             total: totalEntries,
                             showTotal: (total, range) =>
                               `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                             current: currentPage,
                             onChange: (page) => setCurrentPage(page),
                           }}
                           showSorterTooltip={false}
                           rowKey={(record) => record.id}
                           components={components}
                         />
                       </div>
                     </div>
        </div>
    
    </>
  );
};

export default BranchMaster;
